import script from "./Users.vue?vue&type=script&setup=true&lang=ts"
export * from "./Users.vue?vue&type=script&setup=true&lang=ts"

import "./Users.vue?vue&type=style&index=0&id=7c5c49cc&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c5c49cc"]])

export default __exports__